import { useParams, Navigate } from 'react-router-dom';
import { getGuideBySlug, useGuideBody } from '../content/guides';
import { GuideArticle } from '../components/marketing/GuideArticle';

export function GuidePage(): JSX.Element {
  const { slug = '' } = useParams<{ slug: string }>();
  const guide = getGuideBySlug(slug);
  const bodyState = useGuideBody(slug);

  if (!guide) {
    return <Navigate to="/guides" replace />;
  }

  return <GuideArticle guide={guide} bodyState={bodyState} />;
}
